import React, { Component } from 'react';

import{
    FooterConPanel,
    FooterBottom
} from './index.css';


class Footer extends Component {
  constructor(props){
    super(props);
    this.state = {
      
    }
    this.iconCode  = null;//二维码的code
    this.timeVal = null;//要执行延迟
  }
  componentWillMount(){
    
  }
  componentDidMount(){
    
  }
  hover =(e) =>{
    if(this.timeVal){
        //已经触发延迟但是还没有执行
        clearTimeout(this.timeVal);
    }else{
        //是个空的
        if(this.iconCode.className !== 'iconItem codeItem fadeIn '){
            this.iconCode.className = 'iconItem codeItem fadeIn ';

        }
    }
  }
  hoverLeave = () =>{
      this.timeVal = setTimeout(() => {
        this.iconCode.className = 'iconItem codeItem';
        this.timeVal = null;
      }, 2000);
  }
  
  render() {
   
    return (
        <div className={FooterConPanel}>
             <div className="footerTop">
                <div className="topSection topOne">
                    <span className="title" >{lang.template("P_YS_OA_XTTMCENTER_0000035062") /* "客户端下载" */}</span>
                    <a className="allIcons" href="http://ec.yonyoucloud.com/html/index/down.html " target="_blank">
                        <div className="diff" onMouseEnter={this.hover} onMouseLeave={this.hoverLeave}>
                            <span className="iconItem" >
                                <span className="iconInner iconOne"></span>
                                <span className="iconDesc">{lang.template("P_YS_OA_XTSPZX_0000034661") /* "移动端" */}</span>
                                <span className="lgCode"></span>
                            </span>
                            <span className="iconItem codeItem " ref={(ref)=>{this.iconCode = ref;}}>
                                <span className="iconInner2 iconCode"></span>
                                <span className="iconDesc">{lang.template("P_YS_PF_WORKBENCH-FE_0001133314") /* "扫描下载客户端" */}</span>
                            </span>
                        </div>
                        <span className="iconItem">
                            <span className="iconInner iconTwo"></span>
                            <span className="iconDesc">Mac</span>
                        </span>
                        <span className="iconItem">
                            <span className="iconInner iconThree"></span>
                            <span className="iconDesc">Windows</span>
                        </span>
                        
                        <span className="iconItem">
                            <span className="iconInner iconFour"></span>
                            <span className="iconDesc">Win xp</span>
                        </span>
                        
                    </a>
                </div>
                <div className="topSection toptwo">
                    <div className="topTwoItem">
                        <span className="title">{lang.template("P_YS_PF_WORKBENCH-FE_0001133350") /* "用友集团" */}</span>
                        <a className="con" href="http://www.yonyou.com" target="_blank">{lang.template("P_YS_OA_XTTMCENTER_0000035088") /* "用友官网" */}</a>
                        <a className="con" href="http://www.yonyoucloud.com" target="_blank">{lang.template("P_YS_OA_XTTMCENTER_0000035058") /* "用友云官网" */}</a>
                        <a className="con" href="http://market.yonyoucloud.com" target="_blank">{lang.template("P_YS_OA_XTTMCENTER_0000035108") /* "用友云市场" */}</a>
                    </div>
                    <div className="topTwoItem">
                        <span className="title">{lang.template("P_YS_OA_XTTMCENTER_0000035034") /* "联系我们" */}</span>
                        <span className="con">{lang.template("P_YS_PF_WORKBENCH-FE_0001133327") /* "热线电话：010-62438888" */}</span>
                        <span className="con">{lang.template("P_YS_PF_WORKBENCH-FE_0001133420") /* "联系邮箱：diwork@yonyou.com" */}</span>
                    </div>
                </div>
             </div>
             <div className={FooterBottom}>
                <a className="police" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802021935"> {lang.template("OA_web_footer_000000023") /* "京公网安备 11010802021935号" */}</a>
                <p className="company">
                    <span>{lang.template("P_YS_HR_HRRCPDF_0000071186") /* "用友网络科技股份有限公司" */}</span>
                    <span>{lang.template("P_YS_PF_WORKBENCH-FE_0001196918") /* "Copyright ©2021" */}</span>
                    <a target="_blank" href="https://beian.miit.gov.cn/">{lang.template("P_YS_PF_YS-LOGIN_0001196671") /* "京ICP 备05007539号-24" */}</a>
                </p>
             </div>
        </div>
    );
  }
}

export default Footer;
